import React from "react";

export default function TermsInstagram() {
  return (
    <main style={{ padding: 24, maxWidth: 900, margin: "0 auto", fontFamily: "system-ui, sans-serif", lineHeight: 1.6 }}>
      <h1>Términos de Servicio</h1>
      <p><strong>Última actualización:</strong> 23 de diciembre de 2025</p>

      <section style={{ marginTop: 32 }}>
        <h2>1. Aceptación de los Términos</h2>
        <p>
          Al acceder y utilizar Geves ("el Servicio"), usted acepta estar sujeto a estos Términos de Servicio
          y todas las leyes y regulaciones aplicables. Si no está de acuerdo con alguno de estos términos,
          no debe utilizar este Servicio.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>2. Descripción del Servicio</h2>
        <p>
          Geves es una plataforma de gestión de redes sociales que permite a agencias, marcas y creadores de
          contenido conectar y gestionar sus cuentas profesionales de Instagram, TikTok y otras plataformas sociales.
          El Servicio incluye:
        </p>
        <ul>
          <li>Programación y publicación de contenido en múltiples plataformas</li>
          <li>Análisis y seguimiento de métricas de engagement</li>
          <li>Gestión de múltiples cuentas desde una sola interfaz</li>
          <li>Herramientas de colaboración para equipos</li>
        </ul>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>3. Registro y Cuentas de Usuario</h2>
        <p>
          Para utilizar el Servicio, debe crear una cuenta proporcionando información precisa y completa.
          Usted es responsable de mantener la confidencialidad de sus credenciales de acceso y de todas
          las actividades que ocurran bajo su cuenta.
        </p>
        <p>
          Debe notificarnos inmediatamente sobre cualquier uso no autorizado de su cuenta o cualquier
          otra violación de seguridad.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>4. Integración con Plataformas de Terceros</h2>
        <h3>4.1 TikTok</h3>
        <p>
          Nuestra integración con TikTok utiliza las siguientes funcionalidades oficiales:
        </p>
        <ul>
          <li><strong>Login Kit (OAuth):</strong> Para la autenticación y autorización segura del usuario</li>
          <li><strong>Content Posting API:</strong> Para la subida y publicación de vídeos mediante APIs oficiales autorizadas</li>
          <li><strong>Display API:</strong> Para obtener información básica del perfil y métricas de contenido</li>
          <li><strong>Webhooks:</strong> Para recibir notificaciones sobre el estado del procesamiento de contenido</li>
        </ul>

        <h3>4.2 Instagram</h3>
        <p>
          Nuestra integración con Instagram utiliza la API oficial de Meta/Facebook:
        </p>
        <ul>
          <li><strong>Instagram Graph API:</strong> Para publicación de contenido y obtención de métricas</li>
          <li><strong>Facebook Login:</strong> Para autenticación y autorización</li>
          <li><strong>Instagram Business API:</strong> Para gestión de cuentas profesionales</li>
        </ul>

        <h3>4.3 Autorización del Usuario</h3>
        <p>
          Al conectar sus cuentas de redes sociales a Geves:
        </p>
        <ul>
          <li>Usted autoriza explícitamente a Geves para acceder y operar en sus cuentas según los permisos solicitados</li>
          <li>Geves almacena tokens de acceso de forma cifrada y segura</li>
          <li>Geves no almacena ni solicita sus contraseñas de plataformas de terceros</li>
          <li>Puede revocar el acceso en cualquier momento desde la configuración de su cuenta o desde la plataforma correspondiente</li>
        </ul>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>5. Uso Aceptable</h2>
        <p>Al utilizar el Servicio, usted acepta:</p>
        <ul>
          <li>Cumplir con todas las leyes y regulaciones aplicables</li>
          <li>Cumplir con los términos de servicio de las plataformas de terceros (TikTok, Instagram, etc.)</li>
          <li>No utilizar el Servicio para actividades ilegales, fraudulentas o no autorizadas</li>
          <li>No intentar acceder a cuentas o sistemas que no le pertenecen</li>
          <li>No interferir con la seguridad o integridad del Servicio</li>
          <li>No utilizar el Servicio para spam, acoso o distribución de malware</li>
          <li>Respetar los derechos de propiedad intelectual de terceros</li>
        </ul>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>6. Propiedad Intelectual</h2>
        <p>
          El contenido que usted publica a través del Servicio sigue siendo de su propiedad. Al utilizar
          el Servicio, nos otorga una licencia limitada para almacenar, procesar y transmitir su contenido
          únicamente con el propósito de proporcionar el Servicio.
        </p>
        <p>
          Todo el software, diseño, texto, gráficos y otros contenidos del Servicio (excluyendo el contenido
          del usuario) son propiedad de Geves o de sus licenciantes y están protegidos por derechos de autor
          y otras leyes de propiedad intelectual.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>7. Privacidad y Protección de Datos</h2>
        <p>
          Su privacidad es importante para nosotros. El uso de información personal está regido por nuestra
          <a href="/instagram/privacy-policy" style={{ color: "#0066cc" }}>Política de Privacidad</a>,
          que forma parte integral de estos Términos de Servicio.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>8. Limitación de Responsabilidad</h2>
        <p>
          El Servicio se proporciona "tal cual" sin garantías de ningún tipo, ya sean expresas o implícitas.
          En la medida máxima permitida por la ley aplicable:
        </p>
        <ul>
          <li>No garantizamos que el Servicio sea ininterrumpido, seguro o libre de errores</li>
          <li>No somos responsables de pérdidas o daños causados por interrupciones del servicio</li>
          <li>No somos responsables de cambios en las APIs o políticas de plataformas de terceros</li>
          <li>No somos responsables del contenido publicado por los usuarios</li>
          <li>Nuestra responsabilidad total no excederá el monto pagado por usted en los últimos 12 meses</li>
        </ul>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>9. Modificaciones del Servicio y Precios</h2>
        <p>
          Nos reservamos el derecho de modificar o discontinuar el Servicio (o cualquier parte del mismo)
          en cualquier momento con o sin previo aviso. Los precios están sujetos a cambios con un aviso
          previo de 30 días a los usuarios afectados.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>10. Terminación</h2>
        <p>
          Podemos suspender o terminar su acceso al Servicio inmediatamente, sin previo aviso ni responsabilidad,
          por cualquier motivo, incluyendo si usted viola estos Términos de Servicio.
        </p>
        <p>
          Usted puede cancelar su cuenta en cualquier momento desde la configuración de su cuenta.
          Al cancelar, sus datos serán eliminados según lo descrito en nuestra Política de Privacidad.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>11. Ley Aplicable</h2>
        <p>
          Estos términos se regirán e interpretarán de acuerdo con las leyes de Chile, sin dar efecto
          a ningún principio de conflictos de leyes.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>12. Cambios a los Términos</h2>
        <p>
          Nos reservamos el derecho de modificar estos términos en cualquier momento. Le notificaremos
          sobre cambios significativos publicando los nuevos términos en esta página y actualizando la
          fecha de "Última actualización". Su uso continuado del Servicio después de dichos cambios
          constituye su aceptación de los nuevos términos.
        </p>
      </section>

      <section style={{ marginTop: 32 }}>
        <h2>13. Contacto</h2>
        <p>
          Si tiene preguntas sobre estos Términos de Servicio, puede contactarnos en:
        </p>
        <p>
          <strong>Email:</strong> <a href="mailto:legal@geves.cl" style={{ color: "#0066cc" }}>legal@geves.cl</a><br />
          <strong>Website:</strong> <a href="https://calendario.geves.cl" style={{ color: "#0066cc" }}>https://calendario.geves.cl</a>
        </p>
      </section>

      <footer style={{ marginTop: 48, paddingTop: 24, borderTop: "1px solid #e5e7eb", fontSize: 14, color: "#6b7280" }}>
        <p>© 2025 Geves. Todos los derechos reservados.</p>
        <p>
          <a href="/instagram/privacy-policy" style={{ color: "#0066cc", marginRight: 16 }}>Política de Privacidad</a>
          <a href="/instagram/terms-of-service" style={{ color: "#0066cc" }}>Términos de Servicio</a>
        </p>
      </footer>
    </main>
  );
}
